import React from 'react';
import { motion } from 'framer-motion';
import CallButton from '../components/CallButton';
import { menuData } from '../data/menuData';
import SafeIcon from '../common/SafeIcon';
import * as FiIcons from 'react-icons/fi';
import { useLanguage } from '../context/LanguageContext';

const { FiStar } = FiIcons;

export default function Menu() {
  const { t, lang } = useLanguage();

  return (
    <div className="container mx-auto px-4 py-16 max-w-5xl">
      <motion.div initial={{ opacity: 0, y: 20 }} animate={{ opacity: 1, y: 0 }} className="text-center mb-16">
        <h1 className="text-5xl font-bold text-brand-navy mb-4">{t('menu.title')}</h1>
        <div className="h-1 w-24 bg-brand-gold mx-auto rounded mb-6"></div>
        <p className="text-gray-600 text-lg max-w-2xl mx-auto">
          {t('menu.subtitle')}
        </p>
      </motion.div>
      <div className="space-y-20">
        {menuData.map((category, idx) => (
          <motion.div key={idx} initial={{ opacity: 0, y: 30 }} whileInView={{ opacity: 1, y: 0 }} viewport={{ once: true }} transition={{ delay: idx * 0.1 }}>
            <h2 className="text-3xl font-bold text-brand-red mb-8 border-b-2 border-gray-100 pb-4 flex items-center justify-between">
              {category.category[lang]}
              <span className="text-sm font-normal text-gray-400 uppercase tracking-widest">{t('common.selection')}</span>
            </h2>
            <div className="grid grid-cols-1 md:grid-cols-2 gap-x-12 gap-y-8">
              {category.items.map((item, id) => (
                <div key={id} className="flex justify-between items-start group relative">
                  <div className="pr-4">
                    <div className="flex items-center gap-2">
                      <h3 className="text-xl font-semibold text-brand-navy group-hover:text-brand-red transition-colors">
                        {item.name[lang]}
                      </h3>
                      {item.popular && (
                        <span className="bg-brand-gold/10 text-brand-gold text-[10px] font-bold px-2 py-0.5 rounded-full flex items-center gap-1 uppercase">
                          <SafeIcon icon={FiStar} className="text-[10px]" /> {t('common.popular')}
                        </span>
                      )}
                    </div>
                    <p className="text-gray-500 mt-1 text-sm leading-relaxed">{item.desc[lang]}</p>
                  </div>
                  <span className="text-lg font-bold text-brand-gold whitespace-nowrap pt-1">{item.price}</span>
                </div>
              ))}
            </div>
          </motion.div>
        ))}
      </div>
      <div className="mt-20 text-center bg-brand-navy p-12 rounded-[3rem] text-white shadow-2xl relative overflow-hidden">
        {/* Decorative background element */}
        <div className="absolute top-0 right-0 w-64 h-64 bg-brand-red/10 rounded-full -translate-y-1/2 translate-x-1/2 blur-3xl" />
        <h3 className="text-3xl font-bold mb-4">{t('menu.ctaTitle')}</h3>
        <p className="text-gray-300 mb-8 max-w-md mx-auto">{t('menu.ctaText')}</p>
        <CallButton />
      </div>
    </div>
  );
}